import React, { Component } from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import {grey400} from 'material-ui/styles/colors';
import { List, ListItem } from 'material-ui/List';
import MenuItem from 'material-ui/MenuItem';
import MoreIcon from 'material-ui/svg-icons/navigation/more-horiz';
import Subheader from 'material-ui/Subheader';
import Tag from 'material-ui/svg-icons/maps/local-offer';

import * as Colors from '../../../styles/colors';
import * as ParseService from '../../../services/parse';

export function TagListButton(props) {
  return (
    <IconButton {...props} >
      <Tag color={Colors.peterRiver}/>
    </IconButton>
  );
}

export function TagListItem(props) {
  const item = props.item;
  const index = props.index;

  const iconButtonElement = (
    <IconButton >
      
      <MoreIcon color={grey400} />

    </IconButton>
  );

  const tagListItemMenu = (
    <IconMenu 
      iconButtonElement={iconButtonElement}
      anchorOrigin={{vertical: 'center', horizontal: 'left'}}
      targetOrigin={{vertical: 'top', horizontal: 'left'}} >
      <MenuItem onClick={() => props.onDelete(item, index)}>Delete</MenuItem>
    </IconMenu>
  );

  return (
    <ListItem
      primaryText={item.get('text')}
      disabled={true}
      rightIconButton={ tagListItemMenu } />
  );
}

class TagList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      items: props.items,
    }
  }

  handleItemDelete = (item, index) => {
    const items = this.state.items;
    const deletedItems = items.splice(index, 1);

    deletedItems.forEach((item) => {
      ParseService.archive(item);
    });

    this.forceUpdate();
  }
  
  render() {
    const items = this.props.items || [];

    const actions = [
      <FlatButton
        label='Done'
        primary={true}
        onClick={this.props.onClose} />
    ];

    return (
      <Dialog
        title='Tags'
        open={true}
        actions={actions}
        onRequestClose={this.props.onClose} 
        animated={false}
        autoScrollBodyContent={true}
        contentStyle={{maxWidth: '320px'}}>

        <List>
          { items.map((item, index) =>
            <TagListItem 
              key={item.id} 
              item={item}
              onDelete={this.handleItemDelete}
              index={index} />
          )}
        </List>
          
      </Dialog>
    );
  }

}

export default TagList;



// WEBPACK FOOTER //
// ./src/scenes/Assignments/components/TagList.js